import { lazy, StrictMode, Suspense } from 'react';

import { createRoot } from 'react-dom/client';

import { AnalyticsProvider } from './analytics/provider.tsx';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Platform } from './types/index.ts';

import './index.scss';

const OldApp = lazy(() => import('./app-old/App.tsx'));
const App = lazy(() => import('./App.tsx'));

const { VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID, VITE_SEGMENT_APP_KEY } = import.meta.env;

const searchParams = new URLSearchParams(window.location.search);
const isNewGameUi = Number(searchParams.get('version')) > 1;

export const platform = searchParams.get('platform') as Platform | undefined;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AnalyticsProvider
        applicationName="game-ui"
        googleAnalyticsMeasurementIds={[VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID]}
        segmentAppKey={VITE_SEGMENT_APP_KEY}
      >
        <Suspense fallback={<></>}>{isNewGameUi ? <App /> : <OldApp />}</Suspense>
      </AnalyticsProvider>
    </ErrorBoundary>
  </StrictMode>,
);
